module.exports = __webpack_public_path__ + "img/footer_icon.690a7d7c.png";